import { createFileRoute } from "@tanstack/react-router";
import { NewsletterForm } from "@/components/forms/NewsletterForm";
import { Card, CardContent, CardDescription, CardHeader } from "@/components/ui/card";
import { Logo } from "@/components/ui/logo";
import { APP_NAME } from "@/config/constants";
import { ArrowLeft } from "lucide-react";
import { Heading } from "@/components/ui/heading";
import { Button } from "@/components/ui/button";
import { useNavigate } from "@tanstack/react-router";
import { seo } from "@/utilities/seo";
import { useTranslation } from "@/hooks/useTranslation";

export const Route = createFileRoute("/newsletter/")({
  component: NewsletterPage,
  head: () => ({
    meta: [
      { title: "Newsletter - ProgressMade.ai" },
      ...seo({
        title: "Newsletter - ProgressMade.ai",
        description:
          "Join our newsletter to receive regular updates on ProgressMade.ai and our mission to empower your health journey.",
        keywords:
          "Newsletter, ProgressMade, Health Community, Health Goals, Wellness, Sleep, Nutrition, Movement, Founder Story, Health Platform, Sustainable Routines, Well-being, ProgressMade.ai",
        image: "https://progressmade.ai/meta-image.webp",
        canonical: "https://progressmade.ai/newsletter",
      }),
    ],
  }),
});

function NewsletterPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div
      className="p-2 flex h-screen justify-center items-center bg-cover bg-center bg-fixed"
      style={{ backgroundImage: "url('/newsletter_bg.webp')" }}
    >
      <Card className="bg-background max-w-lg min-w-[400px]">
        <CardHeader className="pb-0">
          <div className="absolute left-4 top-4">
            <Button
              variant="outline"
              size="icon"
              className="size-8"
              onClick={() => navigate({ to: "/" })}
            >
              <ArrowLeft />
            </Button>
          </div>

          <div className="flex flex-col items-center gap-1 text-center">
            <Logo className="size-10 mx-auto" iconClassName="size-8" />
            <Heading level="h1" size="h5">
              {t("newsletter.page.title")}
            </Heading>
            <CardDescription className="max-w-sm">
              {t("newsletter.page.description", { appName: APP_NAME })}
            </CardDescription>
          </div>
        </CardHeader>
        <CardContent>
          <NewsletterForm />
        </CardContent>
      </Card>
    </div>
  );
}
